import dashboardLogo from "../Assets/Navbar/dashboardLogo.svg";
import realtimedataLogo from "../Assets/Navbar/realtimedataLogo.svg";
import historicalLogo from "../Assets/Navbar/historicalLogo.svg";
import WeatherSnap_Logo from "../Assets/WelcomeScreen/WeatherSnap_Logo.png";
import HamburgerIcon from "../Assets/SideBar/HamburgerIcon";
import LogoutIcon from "../Assets/Navbar/LogoutIcon.jsx";
import LoginIcon from "../Assets/Navbar/LoginIcon.jsx";
import contactLogo from "../Assets/Navbar/contactLogo.svg";

// import LocationSvg from '../Assets/Navbar/locationSvg'

import locationSvg from "../Assets/Navbar/locationSvg.svg";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../ReduxStore/App/auth.slice";
import {
  setHamburger,
  setMyIndex,
} from "../ReduxStore/App/DashBoard/dashboardSlice";
import toast from "react-hot-toast";
import { Tooltip } from "react-tooltip";
import { logoutApi } from '../api/User'

function Navbar() {
  const location = useLocation();
  const { isAuth, loading } = useSelector((store) => store.auth);
  const { hamburger, theme } = useSelector((store) => store.dashboard);

  const dispatch = useDispatch();
  const logoMap = {
    "/dashboard": dashboardLogo,
    "/near-realtime-data": realtimedataLogo,
    "/historical-data": historicalLogo,
    "/manage-location": locationSvg,
    "/contact": contactLogo,
  };
  const titleAccToLogo = {
    "/dashboard": "Home",
    "/near-realtime-data": "Near Realtime Data",
    "/historical-data": "Graph Data",
    "/manage-location": "Locations",
    "/contact": "Contact",
  };

  const navigate = useNavigate();
  const handleLogout = async () => {
    const res = await logoutApi();
    if (res.success) {
      dispatch(logout());
      dispatch(setMyIndex(0));
      navigate("/");
      toast.success("Successfully logged out ");
    } else {
      toast.error("Failed to log out ");
    }
  };
  return (
    <div className="dark:bg-darkModeSecondaryBgColor bg-secondaryBgColor  ">
      <div className="sm:flex sm:justify-center md:flex lg:hidden">
        <div className="lg:w-[18%] sm:w-[35%]  md:w-[15%] lg:col-start-6 col-end-13">
          <img width={""} src={WeatherSnap_Logo} alt="weather_logo" />
        </div>
      </div>
      <div className="lg:grid lg:grid-cols-12 border-b-[1px] border-blackPrimaryText dark:border-secondaryBgColor h-fit  sm:px-2  lg:px-4   bg-secondaryBgColor w-full text-blackPrimaryText dark:text-darkModeBlackPrimaryText  dark:bg-darkModeSecondaryBgColor sm:flex sm:items-center sm:justify-between sm:gap-2 lg:gap-0 lg:py-0.5 sm:py-2 c">
        {/* ================================== */}
        <div
          onClick={() => dispatch(setHamburger(!hamburger))}
          className="   lg:hidden       cursor-pointer  "
        >
          <HamburgerIcon theme={theme} />
        </div>

        {/* ========================================== */}
        <div className="flex items-center gap-2 lg:col-start-1 col-end-5">
          <img src={logoMap[location.pathname]} alt="" />
          {/* <LocationSvg color={'red'}/> */}

          <p className="font-semibold">{titleAccToLogo[location.pathname]}</p>
        </div>
        <div className="lg:w-[18%] sm:w-[35%] sm:hidden lg:block lg:col-start-6 col-end-12">
          <img width={""} src={WeatherSnap_Logo} alt="weather_logo" />
        </div>
        {!loading && isAuth &&

          (<div
            data-tooltip-id="logout-me"
            data-tooltip-content="Logout "
            data-tooltip-place="bottom"
            data-tooltip-variant="info"
            className=" sm:hidden   cursor-pointer lg:flex lg:justify-end     lg:col-start-12 lg:col-end-13   "
            onClick={handleLogout}
          >
            <LogoutIcon theme={theme} />
          </div>)
        }
        {!loading && !isAuth && location.pathname !== "/" && (
          <div
            data-tooltip-id="login-me"
            data-tooltip-content="Login"
            data-tooltip-place="bottom"
            data-tooltip-variant="info"
            className="sm:hidden cursor-pointer lg:flex lg:justify-end lg:col-start-12 lg:col-end-13"
            onClick={() => navigate("/")}
          >
            <LoginIcon theme={theme} />
          </div>
        )}
      </div>
      <Tooltip id="logout-me" />
      <Tooltip id="login-me" />
    </div>
  );
}

export default Navbar;
